/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class Api404ContextService {
  private pendingRejection: any = null;

  setRejection(rejection: any): void {
    this.pendingRejection = rejection;
  }

  consumeRejection(paramsRejection?: any): any {
    const rejection = paramsRejection || this.pendingRejection;
    this.pendingRejection = null;
    return rejection;
  }
}

export function findHttp404Response(rejection: any): any {
  const candidates = [rejection, _.get(rejection, 'detail'), _.get(rejection, 'detail.detail')];
  return _.find(candidates, function(response) {
    return response && Number(response.status) === 404;
  });
}
